import { Routes } from '@core/constants/routes';
import { useNavigate } from '@core/hooks/navigate.hook';
import { ApiResponse } from '@core/models/common.model';
import axios, { AxiosError, AxiosResponse } from 'axios';

export const apiInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

let navigate: ReturnType<typeof useNavigate> | null = null;

export function setupInterceptors(
  nav: ReturnType<typeof useNavigate>,
  logout: () => void
) {
  navigate = nav;

  apiInstance.interceptors.request.use(
    (config) => {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  apiInstance.interceptors.response.use(
    (
      response: AxiosResponse<ApiResponse<any>>
    ): AxiosResponse<ApiResponse<any>> => response,
    (error: AxiosError): Promise<AxiosError> => {
      if (error.response && error.response.status === 401 && navigate) {
        navigate([Routes.LOGIN]);
        logout();
        localStorage.removeItem('token');
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );
}
